import { assign } from 'xstate5';

import { type LocationSearchMachineAction } from '../../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const setActivePredictionTabForPickup: LocationSearchMachineAction = assign(
  ({ context }) => {
    const pickupLocations = context.predictionLocations?.pickup ?? [];
    const hasPickupLocations = pickupLocations.length > 0;

    const activeTabId = context.activePredictionTab;
    const isLocationTabId = activeTabId === 'location-prediction-tab.locations'; // prettier-ignore

    return {
      activePredictionTab:
        isLocationTabId && hasPickupLocations
          ? ('location-prediction-tab.locations' as const)
          : ('location-prediction-tab.predictions' as const),
    };
  },
);

export const setActivePredictionTabForOutpost: LocationSearchMachineAction = assign(
  ({ context }) => {
    const outpostLocations = context.predictionLocations?.outpost ?? [];
    const hasOutpostLocations = outpostLocations.length > 0;

    const activeTabId = context.activePredictionTab;
    const isLocationTabId = activeTabId === 'location-prediction-tab.locations'; // prettier-ignore

    return {
      activePredictionTab:
        isLocationTabId && hasOutpostLocations
          ? ('location-prediction-tab.locations' as const)
          : ('location-prediction-tab.predictions' as const),
    };
  },
);

export const setPredictionTabToPredictions: LocationSearchMachineAction = assign({
  activePredictionTab: () => 'location-prediction-tab.predictions' as const,
});

export const setPredictionTabToLocations: LocationSearchMachineAction = assign({
  activePredictionTab: () => 'location-prediction-tab.locations' as const,
});
